export const CONFIG = {
    FirebaseDatabaseName: "scoreboards",
};
